import React, { useState, useEffect, useMemo } from "react";

import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Spin } from "antd";
import Productcard from "./product-card.component";
import { fetchMenus } from "../redux/feature/order";
import { useDispatch, useSelector } from "react-redux";

function CustomTabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`dynamic-tabpanel-${index}`}
      aria-labelledby={`dynamic-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 1 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `dynamic-tab-${index}`,
    "aria-controls": `dynamic-tabpanel-${index}`,
  };
}

const DynamicCategoryTabs = ({
  categories,
  merchantId,
  onClickProduct,
  searchPattern,
}) => {
  const dispatch = useDispatch();
  const [value, setValue] = useState(0);
  const { merchantMenus, menuLoading, categoryLoading } = useSelector(
    (state) => state.order
  );

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const categoryId = useMemo(() => {
    return categories.length > value ? categories[value]?.id : null;
  }, [categories, value]);

  useEffect(() => {
    if (categories.length !== 0 && merchantId && categoryLoading === false) {
      dispatch(
        fetchMenus({
          merchantId: merchantId,
          categoryId: categoryId,
          searchPattern,
        })
      );
    }
  }, [
    dispatch,
    categories,
    categoryId,
    merchantId,
    categoryLoading,
    searchPattern,
  ]);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        {searchPattern.length !== 0 ? null : categories.length > 0 ? (
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="dynamic category tabs"
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            sx={{
              pointerEvents: menuLoading ? "none" : "auto",
              opacity: menuLoading ? 0.5 : 1,
              backgroundColor: "#f3f4f6", // Tab bar background color
              borderRadius: 4,
              "& .MuiTabs-indicator": {
                backgroundColor: "#000", // Active tab bar color
              },
            }}
          >
            {categories.map((category, index) => (
              <Tab
                key={category.id}
                label={
                  <span style={{ fontWeight: "bold" }}>{category.title}</span>
                }
                {...a11yProps(index)}
                sx={{
                  "&.Mui-selected": {
                    color: "#000", // Active tab text color
                  },
                }}
              />
            ))}
          </Tabs>
        ) : merchantId ? (
          <Box sx={{ p: 2, textAlign: "center" }}>No available menu</Box>
        ) : null}
      </Box>

      {searchPattern.length !== 0 ? (
        menuLoading ? (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Spin />
          </div>
        ) : (
          <>
            {Array.isArray(merchantMenus) &&
              merchantMenus.map((menu, i) => (
                <Productcard
                  product={menu}
                  key={i}
                  onClickProduct={onClickProduct}
                />
              ))}
          </>
        )
      ) : (
        categories.map((category, index) => (
          <CustomTabPanel key={category.id} value={value} index={index}>
            <div style={{ display: "flex", justifyContent: "center" }}>
              {menuLoading ? (
                <Spin />
              ) : (
                <div
                  style={{
                    display: "flex",
                    rowGap: 10,
                    flexDirection: "column",
                    width: "100%",
                  }}
                >
                  {Array.isArray(merchantMenus) &&
                    merchantMenus.map((menu, i) => (
                      <Productcard
                        product={menu}
                        key={i}
                        onClickProduct={onClickProduct}
                      />
                    ))}
                </div>
              )}
            </div>
          </CustomTabPanel>
        ))
      )}
    </Box>
  );
};

DynamicCategoryTabs.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default React.memo(DynamicCategoryTabs); // Memoized for performance
